"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _fetchReliability = require("./fetchReliability");
Object.keys(_fetchReliability).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fetchReliability[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fetchReliability[key];
    }
  });
});